export default __webpack_public_path__ + "static/media/testline_en.039cba29.jpg";